module.exports = __webpack_public_path__ + "static/media/blinds.66231826.svg";